import { render } from "./priotag.vue?vue&type=template&id=d0a22258"
import script from "./priotag.vue?vue&type=script&lang=js"
export * from "./priotag.vue?vue&type=script&lang=js"

import "./priotag.vue?vue&type=style&index=0&id=d0a22258&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__